import { Box, Link, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { pngs } from "../../app/constants";
import { useTranslation } from "react-i18next";

export const UserInstructions = () => {
  const path = process.env.PUBLIC_URL;
  const { t } = useTranslation();

  const appStoreLinks = () => (
    <Grid xs={12} container spacing={2}>
      <Grid
        xs={12}
        md={6}
        display="flex"
        justifyContent={{ xs: "center", md: "flex-end" }}
      >
        <a href="https://apps.apple.com/us/app/simpl2/id1660627978">
          <img src={path + pngs.appleStore} alt="Apple Store" height={40} />
        </a>
      </Grid>
      <Grid
        xs={12}
        md={6}
        display="flex"
        justifyContent={{ xs: "center", md: "flex-start" }}
      >
        <a href="https://play.google.com/store/apps/details?id=com.simpl.simpl2">
          <img src={path + pngs.playStore} alt="Play Store" height={40} />
        </a>
      </Grid>
    </Grid>
  );

  const instructionsText = () => {
    return (
      <Typography fontSize={20} fontWeight={400} color="primary">
        <>
          <p>{t("Your account has been created!")}</p>
          {/* TODO - Figure out how to put bold text in the middle of a translated string */}
          <p>
            Download the <strong>SIMPL Mobile App</strong> from the app store to
            get started.
            <br />
            Or continue to web login{" "}
            <Link href="/" color="primary">
              simpl-platform.org
            </Link>
          </p>
        </>
      </Typography>
    );
  };

  return (
    <Grid container spacing={2} padding={2}>
      <Grid
        xs={12}
        display="flex"
        justifyContent={{ xs: "center", lg: "start" }}
      >
        <img src={path + pngs.simplLogo} alt="SIMPL Logo" />
      </Grid>

      <Grid
        xs={12}
        container
        direction={{ xs: "row", lg: "row-reverse" }}
        px={2}
      >
        <Grid xs={1} display={{ xs: "none", lg: "block" }} />
        <Grid
          xs={12}
          lg={5}
          justifyContent="center"
          display="flex"
          alignItems="center"
          flexDirection="column"
        >
          <img
            src={path + pngs.simplExample}
            alt="app example"
            style={{ width: "100%", maxWidth: "450px" }}
          />
          <Box display={{ xs: "none", lg: "block" }}>{appStoreLinks()}</Box>
        </Grid>
        <Grid
          xs={12}
          lg={5}
          display="flex"
          justifyContent="center"
          flexDirection="column"
          textAlign="center"
        >
          {instructionsText()}
          <Box display={{ xs: "block", lg: "none" }}>{appStoreLinks()}</Box>
        </Grid>
      </Grid>
    </Grid>
  );
};
